import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SupervisorDetailsResponse } from "@/central-atoms/everest-fleet-pwa/responses";

interface SupervisorDetailsState {
  data: SupervisorDetailsResponse | null;
  selectedHub: string | null;
}

const initialState: SupervisorDetailsState = {
  data: null,
  selectedHub: null,
};

const supervisorDetailsSlice = createSlice({
  name: "supervisorDetails",
  initialState,
  reducers: {
    setSupervisorDetails: (
      state,
      action: PayloadAction<SupervisorDetailsResponse>
    ) => {
      state.data = action.payload;
      if (action.payload.data.hub_list.length > 0) {
        state.selectedHub = action.payload.data.hub_list[0].name;
      }
    },
    setSelectedHub: (state, action: PayloadAction<string>) => {
      state.selectedHub = action.payload;
    },
  },
});

export const { setSupervisorDetails, setSelectedHub } =
  supervisorDetailsSlice.actions;
export default supervisorDetailsSlice.reducer;
